
//#region KAFKA

const KAFKA_HOST = process.env.KAFKA_HOST || 'csp-backend-services:9093';  //kafka host name
const KAFKA_ACTIVE = process.env.KAFKA_ACTIVE || 1;
const KAFKA_CORE_TOPIC = process.env.KAFKA_CORE_TOPIC || 'insight-core-event';
const SERVER_SOCKET_PATH = process.env.SERVER_SOCKET_PATH || '/insws';
const SERVER_SOCKET_PING_INTERVAL = process.env.SERVER_SOCKET_PING_INTERVAL || 55000;
const SERVER_SOCKET_PING_TIMEOUT = process.env.SERVER_SOCKET_PING_TIMEOUT || 6000000;
const SERVER_SOCKET_UPGRADE_TIMEOUT = process.env.SERVER_SOCKET_UPGRADE_TIMEOUT || 20000;
const SERVER_SOCKET_RECONNECTION_DELAY = process.env.SERVER_SOCKET_RECONNECTION_DELAY || 1000;
const SERVER_SOCKET_RECONNCTION_DELAY_MAX = process.env.SERVER_SOCKET_RECONNCTION_DELAY_MAX || 5000;
const SERVER_SOCKET_MAX_HTTP_BUFFER_SIZE = process.env.SERVER_SOCKET_MAX_HTTP_BUFFER_SIZE || 100000000;
const UI_SOCKET_TIMEOUT = process.env.UI_SOCKET_TIMEOUT || 6000000;
const LOG_FILE_PATH = process.env.LOG_FILE_PATH || './logs/monitor-middleware.log';
const LOG_CONSOLE_LEVEL = process.env.LOG_CONSOLE_LEVEL || 'info';
const LOG_FILE_LEVEL = process.env.LOG_FILE_LEVEL || 'info';
const LOG_FILE_ROTATE_FREQUENCY = process.env.LOG_FILE_ROTATE_FREQUENCY || 'HH';  // HH : creates log file every hour and appends it EoD to create single file.
const LOG_FILE_ZIP_ARCHIVED = process.env.LOG_FILE_ZIP_ARCHIVED || true;
const LOG_FILE_MAX_SIZE = process.env.LOG_FILE_MAX_SIZE || '1024m';  //max size 1GB
const SESSION_INTERVAL = process.env.SESSION_INTERVAL || 300000; // 5 mins
const IDLE_TIME_INTERVAL = process.env.IDLE_TIME_INTERVAL || 240000; // 4mins to detect idle state in application                                                                                         // OR can be max number of files : 5 If null : wont delete any files.
const EXPIRY_REMINDER_INTERVAL = Number(SESSION_INTERVAL) - Number(IDLE_TIME_INTERVAL) // 1min, should be less than SESSION_INTERVAL
const REDIS_HOST = process.env.REDIS_HOST;
const REDIS_HOST_PORT = process.env.REDIS_HOST_PORT || '6379';
const REDIS_HOST_SSL = process.env.REDIS_HOST_SSL || false;
const REDIS_CA_PATH = process.env.REDIS_CA_PATH;
const REDIS_HOST_CREDENTIAL = process.env.REDIS_HOST_CREDENTIAL || '';
const KAFKA_HOST_SSL = process.env.KAFKA_HOST_SSL || false;
const KAFKA_CA_PATH = process.env.KAFKA_CA_PATH;
const KAFKA_HOST_CREDENTIAL = process.env.KAFKA_HOST_CREDENTIAL || '';

module.exports.config = {

    monitorui: process.env.MONITORUI_HOST,
    redis: REDIS_HOST,
    redisPort: REDIS_HOST_PORT,
    redisCredential: REDIS_HOST_CREDENTIAL,
    redisSSL: REDIS_HOST_SSL,
    redisCAPath: REDIS_CA_PATH,
    kafkaSSL: KAFKA_HOST_SSL,
    kafkaCAPath: KAFKA_CA_PATH,
    kafkaCredential: KAFKA_HOST_CREDENTIAL,
    EXTEND_TTL_SESSION: Number(SESSION_INTERVAL),  //5mins in mSec
    sessionInterval: Number(SESSION_INTERVAL), // session dialog every 5 mins(in mSec)
    refreshTokenInterval: Number(SESSION_INTERVAL) - Number(EXPIRY_REMINDER_INTERVAL), // refresh token every 4 mins(in mSec) 
    expiry_reminder_interval: Number(EXPIRY_REMINDER_INTERVAL),
    idle_time_interval: Number(IDLE_TIME_INTERVAL),
    kafka: {
        host: KAFKA_HOST.trim() || 'csp-backend-services:9093',
        pollInterval: 2000,
        maxSize: 1048576,
        active: Number(KAFKA_ACTIVE) || 1,
        topic: KAFKA_CORE_TOPIC.trim() || 'insight-core-event'
    },
    webServerSocket: {
        path: SERVER_SOCKET_PATH,
        pingInterval: parseInt(SERVER_SOCKET_PING_INTERVAL), //was 10k, how many ms before sending a new ping packet, => how often to send a ping
        pingTimeout: parseInt(SERVER_SOCKET_PING_TIMEOUT), //should be above 30k to fix disconnection issue how many ms without a pong packet to consider the connection closed
        upgradeTimeout: parseInt(SERVER_SOCKET_UPGRADE_TIMEOUT), // default value is 10000ms, try changing it to 20k or more
        reconnectionDelay: parseInt(SERVER_SOCKET_RECONNECTION_DELAY),
        reconnectionDelayMax: parseInt(SERVER_SOCKET_RECONNCTION_DELAY_MAX),
        maxHttpBufferSize: SERVER_SOCKET_MAX_HTTP_BUFFER_SIZE //100 mb
    },
    webUISocket: {
        reconnection: true,
        reconnectionDelay: SERVER_SOCKET_RECONNECTION_DELAY,
        reconnectionDelayMax: SERVER_SOCKET_RECONNCTION_DELAY_MAX,
        reconnectionAttempts: Infinity,
        timeout: UI_SOCKET_TIMEOUT
    },
    log: {
        console_level: LOG_CONSOLE_LEVEL,
        filePath: LOG_FILE_PATH,
        fileLevel: LOG_FILE_LEVEL,
        datePattern: LOG_FILE_ROTATE_FREQUENCY ,
        zippedArchive: LOG_FILE_ZIP_ARCHIVED,
        maxSize: LOG_FILE_MAX_SIZE
    }

}